import React, { useState } from 'react';
import {
  Box,
  Stepper,
  Step,
  StepButton,
  Paper,
  Typography,
} from '@mui/material';
import type { PlanEntity } from '@/types/run-stage.types';
import { MapMaterials } from './MapMaterials';
import { MapMachines } from './MapMachines';
import { PlanSummary } from './PlanSummary';

interface PlanStageProps {
  plan: PlanEntity;
  runId?: string;
  runUid?: string;
  isReadOnly?: boolean;
}

const STEPS = ['Map Materials', 'Map Machines', 'Plan Summary'];

export const PlanStage: React.FC<PlanStageProps> = ({ plan, runId, runUid, isReadOnly = false }) => {
  const [activeStep, setActiveStep] = useState(0);

  const effectiveRunId = runId || plan.runId;

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Stepper nav */}
      <Paper variant="outlined" sx={{ px: 3, py: 1.5, mb: 2, flexShrink: 0 }}>
        <Stepper nonLinear activeStep={activeStep}>
          {STEPS.map((label, index) => (
            <Step key={label}>
              <StepButton onClick={() => setActiveStep(index)}>
                <Typography variant="body2">{label}</Typography>
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </Paper>

      {/* Step content */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {activeStep === 0 && (
          <MapMaterials
            nodes={plan.nodes ?? []}
            runId={effectiveRunId}
            runUid={runUid}
            isReadOnly={isReadOnly}
          />
        )}
        {activeStep === 1 && (
          <MapMachines
            steps={plan.steps ?? []}
            machines={plan.machines ?? []}
            runId={effectiveRunId}
            runUid={runUid}
            isReadOnly={isReadOnly}
          />
        )}
        {activeStep === 2 && (
          <PlanSummary plan={plan} isReadOnly={isReadOnly} />
        )}
      </Box>
    </Box>
  );
};
